<template>
    <v-app>
        <Toolbar title="Group Detail"/>
        <v-content>
            <v-layout row>
                <v-flex xs12 sm12 offset-sm0>
                    <v-card>
                        <v-card-title primary-title>
                            <v-btn @click="$router.push({path: '/groups'})">
                                <v-icon dark>arrow_back</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <div>
                                <div class="headline">{{ groupData['name'] }}</div>
                                <span class="grey--text">ID: {{ groupId }}</span>
                            </div>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-flex xs12 md10 offset-md1 v-if="userCanOrder">
                <v-toolbar color="blue darken-2" dark>
                    <v-toolbar-title></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="blue" @click="$router.push(orderLink)">List Group Orders</v-btn>
                </v-toolbar>
            </v-flex>

            <v-card>
                <v-card-title primary-title>
                    <h3 class="headline mb-0">Devices</h3>
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="$store.state.searchPhrase"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="deviceHeaders"
                        :items="deviceData"
                        :search="$store.state.searchPhrase"
                        :rows-per-page-items="rowsPerPage"
                >
                    <template slot="items" slot-scope="props">
                        <td class="subheading" @click="routeLink(props.item.serial)">
                            {{ props.item.serial }}
                        </td>
                        <td class="subheading" @click="routeLink(props.item.serial)">{{
                            props.item['merchant.merchantid']
                            }}
                        </td>
                        <td class="subheading" @click="routeLink(props.item.serial)">{{
                            props.item['merchant.terminalid']
                            }}
                        </td>
                        <td class="subheading" @click="routeLink(props.item.serial)">{{ props.item['header.line1'] }}
                        </td>
                        <td class="subheading" @click="routeLink(props.item.serial)">{{ props.item['device.name'] }}
                        </td>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </v-data-table>
            </v-card>
            <v-layout row wrap>
                <GroupUsers :group="groupId" :users="groupData.users"/>
                <GroupRename :group="groupId"/>
            </v-layout>
        </v-content>
    </v-app>
</template>

<script>
    import {mapActions} from 'vuex'
    import Toolbar from '../components/Toolbar'
    import GroupUsers from '../components/GroupUsers'
    import GroupRename from '../components/GroupRename'

    const fb = require('../firebase')

    export default {
        name: "Group",
        components: {Toolbar, GroupUsers, GroupRename},
        data() {
            return {
                search: '',
                rowsPerPage: [25, 50, 100, {'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1}],
                deviceHeaders: [
                    {text: 'Serial', align: 'left', sortable: true, value: 'serial'},
                    {text: 'Merchant ID', align: 'left', sortable: true, value: 'merchant.merchantid'},
                    {text: 'Terminal ID', align: 'left', sortable: true, value: 'merchant.terminalid'},
                    {text: 'Business', align: 'left', sortable: true, value: 'header.line1'},
                    {text: 'Device Name', align: 'left', sortable: true, value: 'device.name'}
                ],
                renameDialog: false,
                renameGroupText: '',
                outputArray: []
            }
        },
        mounted() {
            // console.log(this.groupId)

            if (!this.isUserLoggedIn()) {
                this.$router.push({path: '/signin'})
            }
            if (this.groupId === undefined || this.groupId === 'undefined') {
                this.$router.push({path: '/groups'})
            }

            this.fetchAll()
            /*
                        console.log('here')
                        fb.settingsCollection
                            .get()
                            .then(function(settings) {
                                if (settings.empty) {
                                    console.log('nothing found')
                                    return
                                }
                                settings.forEach(function(setting) {
                                    if (setting.exists) {
                                        let this_data = setting.data()
                                        if (this_data['autoupdate.s3-bucket-name'] === 'goodbox') {
                                            console.log(setting.id)
                                            console.log(this_data)
                                            fb.settingsCollection.doc(setting.id)
                                                .set({
                                                    'goodbox.force_offline': true,
                                                    'merchant.no_receipt': true,
                                                    'partner.url': 'http://goodbox-proxy-1590989627.eu-west-2.elb.amazonaws.com/transactions',
                                                    'goodbox.menu_timeout': 30,
                                                    'goodbox.skip_cancel': true,
                                                    'goodbox.offline_idle_timer': 30,
                                                    'goodbox.offline_idle': true,
                                                     'donation.mode_offline': true,
                                                    'merchant.max_offline': 1000,
                                                    "goodbox.enabled": true,
                                                    "goodbox.mode": false,
                                                    "gsm.apn": 'wlapn.com'
                                                }, {merge: true})
                                        }
                                    }
                                })
                            }) */
        },
        computed: {
            groupId: function () {
                return this.$route.params.id
            },
            groupData: function () {
                let gd = this.$store.state.groups[this.groupId]
                if (gd === undefined) {
                    return {}
                }
                return gd
            },
            orderLink: function () {
                return '/orders/' + this.groupId
            },
            userCanOrder: function () {
                if (this.$store.state.users[fb.auth.currentUser.uid] !== undefined) {
                    return this.$store.state.users[fb.auth.currentUser.uid].orders === true
                } else {
                    return false
                }
            },
            /* reportData: function () {
                let groupObject = this.$store.state.groups[this.groupId]

                let devices = []

                if (groupObject !== undefined) {
                    devices = Object.values(groupObject['devices'])
                }

                let output = []
                if (devices.length > 0) {
                    devices.forEach((device) => {
                        let did = 'castles_' + device + '@kineticsmart.com'
                        let d = this.$store.state.devices[did]
                        d.id = did
                        d.serial = device
                        let e = {
                            'serial': d.serial,
                            'merchantId': d['merchant.merchantid'],
                            'terminalId': d['merchant.terminalid'],
                            'businessName': d['header.line1'],
                            'startMAC': d['merchant.master_key']
                        }
                        if (d['merchant.terminalid'] != '33420008') {
                            output.push(e)
                        }
                    })
                }

                if (output === undefined) {
                    output = []
                }
                return output
            }, */
            deviceData: function () {
                let groupObject = this.$store.state.groups[this.groupId]

                let devices = []

                if (groupObject !== undefined) {
                    devices = Object.values(groupObject['devices'])
                }

                let output = []
                if (devices.length > 0) {
                    devices.forEach((device) => {
                        let did = 'castles_' + device + '@kineticsmart.com'
                        let d = this.$store.state.devices[did]
                        d.id = did
                        d.serial = device
                        output.push(d)
                    })
                }

                if (output === undefined) {
                    output = []
                }
                return output
            }
        },
        methods: {
            ...mapActions(['isUserLoggedIn', 'fetchAll']),
            routeLink: function (val) {
                this.$router.push('/device/' + this.groupId + '/' + val)
            }
        }
    }
</script>

<style scoped>

</style>
